
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { SearchArticle } from '@/common/api/models.pleased';
import ArticleListItem from './ArticleListItem.vue';
import loading from '@/components/loading';
import { emitArticleAutocompleteFocused, emitOpenArticle } from '@/common/eventBus';
import SearchIcon from './icons/SearchIcon.vue';
import * as PleasedApi from '@/common/api/api.pleased';
import { reportingService } from '@/common/reporting';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';
import { analytics } from '@/common/logs/EventLogger';

@Component({
  directives: { loading, trackClick },
  components: {
    ArticleListItem,
    SearchIcon,
  },
})
export default class RelatedArticles extends Vue {
  @Prop({ type: Number, required: true }) articleId!: number;

  readonly INITIAL_ARTICLE_COUNT = 3;
  readonly BTN_EVTS = BTN_EVTS;

  isShowingAllArticles = false;
  articles: SearchArticle[] = [];

  get showArticleLimit () {
    return this.isShowingAllArticles ? this.articles.length : this.INITIAL_ARTICLE_COUNT;
  }

  get showArticles () {
    return this.articles.slice(0, this.showArticleLimit);
  }

  openArticle (item: SearchArticle) {
    reportingService.selectedArticleFromRelated(item.id);
    analytics.trackClick({
      name: BTN_EVTS.ARTICLE_RELATED_ARTICLE,
      selection: this.articleId,
      metadata: { relatedArticle: item.id, title: item.title },
    });

    emitOpenArticle({
      isOpen: true,
      articleId: item.id,
      fetchArticle: true,
      isFromAutocomplete: true,
      categoryName: item.categoryName,
    });
  }

  @Watch('articleId', { immediate: true })
  async loadRelatedArticles () {
    const relatedArticles = await PleasedApi.getRelatedArticles.cached({ articleId: this.articleId });
    this.articles = relatedArticles.data;
    this.isShowingAllArticles = this.articles.length <= this.INITIAL_ARTICLE_COUNT;
  }

  handleShowMore () {
    this.isShowingAllArticles = true;
  }

  searchMore () {
    emitArticleAutocompleteFocused(true);
  }
}
